<template>
  <div class="smsInquiry">
    <div class="condition">
      <el-form ref="form" inline :model="form" :rules="rules" label-width="80px">
        <el-form-item label="开始日期" prop="beginTime">
          <el-date-picker class="form_date" v-model="form.beginTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" :editable="false" :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime">
          <el-date-picker class="form_date" v-model="form.endTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" :editable="false" :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input class="form_input" v-model="form.phone" placeholder="请输入手机号"></el-input>
          <el-button class="form_btn" type="primary" plain @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="list"
        border
        stripe
        style="width: 100%">
        <el-table-column type="index" width="50" :index="indexMethod"> </el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="140"></el-table-column>
        <el-table-column prop="msgCode" label="验证码" min-width="120"></el-table-column>
        <el-table-column prop="createTime" label="时间" min-width="180"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="pageNo"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="pageNoChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import $api from '@/utils/request'

export default {
  name: 'smsInquiry',
  data () {
    return {
      form: {
        beginTime: '',
        endTime: '',
        phone: ''
      },
      rules: {
        beginTime: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ]
      },
      pageNo: 1,
      total: 0,
      list: []
    }
  },
  methods: {
    indexMethod(index) {
      return (this.pageNo - 1) * 20 + index + 1;
    },
    getList () {
      $api.post('/tmp-msg-code/page', {
        ...this.form,
        pageNo: this.pageNo,
        pageSize: 20
      }).then(res => {
        if (res.code == 200) {
          const data = res.data
          this.total = data.total
          this.list = data.records
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    search() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.pageNo = 1
          this.getList()
        }
      })
    },
    pageNoChange(val) {
      this.pageNo = val
      this.getList()
    }
  },
  created() {
    const today = new Date().Format('yyyy-MM-dd')
    this.form.beginTime = today
    this.form.endTime = today
  }
}
</script>

<style lang="less" scoped>
  .smsInquiry{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .condition{
    box-sizing: border-box;
    margin: 20px 0 0 0;
    padding: 0 24px;
    width: 100%;
  }

  .form_date{
    width: 210px;
  }

  .form_input{
    width: 140px;
  }

  .form_btn{
    margin: 0 0 0 10px;
  }

  .table{
    box-sizing: border-box;
    margin: 10px 0 0 0;
    padding: 0 24px;
    width: 100%;
  }

  .pagination{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 10px 0 0 0;
    padding: 0 24px;
    width: 100%;
  }
</style>